import { EventEmitter, OnInit } from '@angular/core';
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
var SetcustomfieldvalueBlockComponent = /** @class */ (function () {
    function SetcustomfieldvalueBlockComponent(confirmationBoxHelper, ajsScope, workflowService) {
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.ajsScope = ajsScope;
        this.workflowService = workflowService;
        this.isEdit = false;
        this.activeField = {};
        this.isConditional = false;
        this.isMarketPlaceView = false;
        this.hasChild = false;
        this.allFields = {};
        this.outputModel = new EventEmitter();
        this.close = new EventEmitter();
        this.isReadOnlyMode = false;
    }
    SetcustomfieldvalueBlockComponent.prototype.ngOnInit = function () {
        this.oldModel = JSON.stringify(Object.assign({}, this.inputModel));
        this.showDeleteBtn = this.isMarketPlaceView ? false : this.isEdit;
        if (this.isEdit) {
            this.activeCustomField = this.allFields[this.inputModel.model['col_name']];
        }
        this.setDisplayValues();
    };
    SetcustomfieldvalueBlockComponent.prototype.closeModal = function () {
        this.close.emit(this.isEdit);
    };
    SetcustomfieldvalueBlockComponent.prototype.onSelectField = function (selected) {
        if (selected) {
            this.activeCustomField = this.allFields[selected];
            this.inputModel.model['templateId'] = this.activeCustomField['templateId'];
            this.inputModel.model['value'] = '';
            return;
        }
    };
    SetcustomfieldvalueBlockComponent.prototype.addValue = function () {
        this.inputModel.model.textField = this.activeCustomField.text;
        this.setDisplayValues();
        this.newModel = JSON.stringify(Object.assign({}, this.inputModel));
        if (this.oldModel === this.newModel) {
            this.workflowService.triggerEvent({ 'isUpdated': false, 'isEdit': this.isEdit, 'action': 'valueChanged' });
        }
        else {
            this.workflowService.triggerEvent({ 'isUpdated': true, 'isEdit': this.isEdit, 'action': 'valueChanged' });
        }
        this.outputModel.emit(this.inputModel);
    };
    SetcustomfieldvalueBlockComponent.prototype.removeCell = function () {
        var _this = this;
        this.confirmationBoxHelper
            .getConfirmation(this.deleteMessage, this.ajsScope)
            .then(function () {
            _this.close.emit('remove');
        });
    };
    SetcustomfieldvalueBlockComponent.prototype.validateItems = function () {
        if (!this.inputModel.model['col_name'] || !this.inputModel.model['value']) {
            return true;
        }
        return this.isConditional ? this.inputModel.condition.operator === '' || this.inputModel.condition.value === '' : false;
    };
    SetcustomfieldvalueBlockComponent.prototype.setDisplayValues = function () {
        var _this = this;
        this.inputModel.config.customFields.forEach(function (item) {
            if (item.fields.length > 0) {
                item.fields.forEach(function (field) {
                    if (field.col_name == _this.inputModel.model['col_name']) {
                        _this.inputModel.model['displayColumnName'] = field.text;
                        if (field.options) {
                            var matchedOption = field.options.find(function (option) { return option.id == _this.inputModel.model.value; });
                            _this.inputModel.model['displayColumnValue'] = matchedOption.text;
                        }
                    }
                });
            }
        });
    };
    return SetcustomfieldvalueBlockComponent;
}());
export { SetcustomfieldvalueBlockComponent };
